module.exports = __webpack_public_path__ + "img/34@2x.03de70aa.png";